import { CPLAnalytics } from "setup/appInsights/CPLAnalytics";
import CreditControlStatusSummariesTable from "./components/CreditControlStatusSummariesTable";
import PageWrapper from "../shared/PageWrapper";

const CreditControlStatusPage: React.FC = () => {
  return (
    <CPLAnalytics pageName="Credit Control Status">
      <PageWrapper data-test-id="credit-control-statuses-page__back-button" title="Credit Control Status">
        <CreditControlStatusSummariesTable />
      </PageWrapper>
    </CPLAnalytics>
  );
};

export default CreditControlStatusPage;
